import { DOCUMENT } from '@angular/common';
import { Pipe, PipeTransform, inject } from '@angular/core';

@Pipe({
  name: 'stripHtml',
  standalone: true
})
export class StripHtmlPipe implements PipeTransform {
  private readonly div = inject(DOCUMENT).createElement('div');

  transform(value: string): string {
    this.div.innerHTML = value || '';
    return this.div.textContent || this.div.innerText || '';
  }
}
